import TriggersEmpty from "../components/TriggersEmpty";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default function EndCallTriggersTable(props) {
  const { endCallTriggers, onEdit, onDelete, showActions = true } = props;

  if (endCallTriggers.length === 0) {
    return <TriggersEmpty />;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>Event name</TableHeader>
          {showActions && <TableHeader>Action</TableHeader>}
        </TableRow>
      </TableHead>
      <TableBody>
        {endCallTriggers.length > 0 &&
          endCallTriggers.map((item, index) => (
            <TableRow
              className="ml-8"
              key={index}
            >
              <TableCell className="min-w-[400px]">
                <p className="whitespace-normal text-sm">{item.actionName}</p>
              </TableCell>
              {showActions && (
                <TableCell>
                  <div className="flex flex-row gap-x-2">
                    <Button
                      outline
                      onClick={() => onEdit({ isOpen: true, item, index })}
                    >
                      <PencilIcon />
                    </Button>
                    <Button
                      outline
                      onClick={() => onDelete({ isOpen: true, item, index })}
                    >
                      <TrashIcon />
                    </Button>
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}
